export const toggleHelpSideBar = () => (
  (dispatch) => {
    dispatch({
      type: 'TOGGLE_HELP_SIDEBAR',
    });
  }
);

export const updateBackgroundImage = highlightedBox => (
  (dispatch) => {
    dispatch({
      highlightedBox,
      type: 'UPDATE_BACKGROUND_IMAGE',
    });
  }
);



// WEBPACK FOOTER //
// ./src-react/VisualStatic/VisualStaticActions.jsx